import { define } from "../../../../utils/typeUtils"
import { useSystemStateHooks } from "../../../system"
import { useCommonActions } from "./commonActions"

export const useHoardActions = () => {
    const stateCompanyId = useSystemStateHooks().companyId

    const commonActions = useCommonActions()

    return (paramCompanyId?: string) => {
        const companyId = define(paramCompanyId || stateCompanyId)
        const hoardCommonActions = commonActions(companyId)
        
        const countHoards = hoardCommonActions.countHoards

        const saveHoard = hoardCommonActions.saveHoard

        const saveHoardWithFile = hoardCommonActions.saveHoardWithFile

        return {
            countHoards,
            saveHoard,
            saveHoardWithFile
        }
    }
}
